import { GoArrowLeft } from "react-icons/go";
import { useNavigate } from "react-router-dom";
import { FaCloudUploadAlt } from "react-icons/fa";
import React, { useState } from "react";
import Symbols from "./modals/Symbol";
import { GoArrowUp } from "react-icons/go";
import { GoArrowDown } from "react-icons/go";
import { FaTrash } from "react-icons/fa";
import { useEffect } from "react";

import "react-datepicker/dist/react-datepicker.css";
import { useContext } from "react";
import { SafeAreaContext } from "../../App";
import PackageModal from "./modals/PackageModal";
import TradeSymbol from "./modals/TradeSymbol";
import TakeProfitSection from "./modals/TakeProfit";
import FileService from "../../services/File";
import SignalsService from "../../services/Signals";
import PercentageModal from "./modals/PercentageModal";

export default function CreateSignal() {
  const { setSafeAreaColor } = useContext(SafeAreaContext);

  useEffect(() => {
    setSafeAreaColor({ background: "#6366f1" });
  }, []);

  const navigation = useNavigate();
  const fileInputRef = React.useRef();
  const [previewUrl, setPreviewUrl] = useState("");
  const [imageId, setImageId] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [selectedSymbol, setSelectedSymbol] = useState(null);
  const [signalActionStatus, setSignalActionStatus] = useState("");
  const [priceTypeStatus, setPriceTypeStatus] = useState(null);
  const [accountStatus, setAccountStatus] = useState(null);
  const [takeProfit, setTakeProfit] = useState([{ id: 1, price: "" }]);
  const [stopLoss, setStopLoss] = useState(null);
  const [trigger, setTrigger] = useState(null);
  const [expirationDate, setExpirationDate] = useState("");
  const [selectedExpirationDate, setSelectedExpirationDate] = useState(null);
  const [optionalNote, setOptionalNote] = useState("");
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [isPremiumSignal, setIsPremiumSignal] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [selectedTimeFrame, setSelectedTimeFrame] = useState("");
  const [riskLevel, setRiskLevel] = useState(0);
  const [confidence, setConfidence] = useState(0);

  const expirationOptions = [
    {
      label: "1 Hour",
      date: new Date(Date.now() + 60 * 60 * 1000).toISOString().slice(0, 16),
    },
    {
      label: "4 Hours",
      date: new Date(Date.now() + 4 * 60 * 60 * 1000)
        .toISOString()
        .slice(0, 16),
    },
    {
      label: "1 Day",
      date: new Date(Date.now() + 24 * 60 * 60 * 1000)
        .toISOString()
        .slice(0, 16),
    },
    {
      label: "1 Week",
      date: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
        .toISOString()
        .slice(0, 16),
    },
  ];

  const timeFrames = [
    { label: "1 Min", value: "1min" },
    { label: "5 Mins", value: "5min" },
    { label: "15 Mins", value: "15min" },
    { label: "30 Mins", value: "30min" },
    { label: "1 Hour", value: "1h" },
    { label: "4 Hours", value: "4h" },
  ];

  const handleSelectedPackge = (pkg) => {
    setSelectedPackage(pkg);
    console.log("Selected package:", pkg);
  };

  const handleSubmit = async () => {
    try {
      const formattedTakeProfit = takeProfit.map((tp) => ({
        target: Number(tp.price),
        done: false,
      }));

      const signalData = {
        type: signalActionStatus.toLowerCase(),
        limit: Number(priceTypeStatus),
        tp: formattedTakeProfit,
        sl: { target: Number(stopLoss), done: false },
        symbol: selectedSymbol?._id,
        packageId: selectedPackage?._id,
        image: imageId,
        description: optionalNote,
        expirationDate: new Date(expirationDate).toISOString(),
        isPremium: isPremiumSignal || false,
        trigger: { target: parseInt(trigger), done: false },
        timeframe: selectedTimeFrame,
        risk: riskLevel * 10,
        confidence: confidence * 10,
      };
      console.log("Signal Data:", signalData);

      const response = await SignalsService.uploadSignal(signalData);
      sessionStorage.clear();
      if (response.data) {
        setTimeout(() => {
          navigation("/dashboard");
        }, 200);
      }
      console.log("publish res:", response);
    } catch (error) {
      console.error("Error creating signal:", error);
    }
  };

  function onBackBtnClick() {
    navigation("/signal");
  }

  const handleDivClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = async (files) => {
    const file = files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setPreviewUrl(base64String);
        sessionStorage.setItem("signalImage", base64String);
      };
      reader.readAsDataURL(file);
    }

    setIsUploading(true);

    try {
      const res = await FileService.uploadFile(formData);
      setImageId(res?.data?.message?._id);
      console.log(res);
    } catch (error) {
      console.error("Upload failed", error);
    } finally {
      setIsUploading(false);
    }
  };

  function handleSelectItemsFromModal(item) {
    console.log("Selected symbol:", item);
    setSelectedSymbol(item);
    setOpenModal(false);
  }

  function safeJSONParse(value, fallback = null) {
    try {
      return value ? JSON.parse(value) : fallback;
    } catch {
      return fallback;
    }
  }

  //session storage
  useEffect(() => {
    const img = sessionStorage.getItem("signalImage");
    const trSymbol = safeJSONParse(
      sessionStorage.getItem("tradingSymbol"),
      null,
    );
    const signalAct = sessionStorage.getItem("signalAction");
    const accountStatus = safeJSONParse(
      sessionStorage.getItem("accountType"),
      null,
    );
    const optionNote = safeJSONParse(
      sessionStorage.getItem("optionalNote"),
      "",
    );
    const expire = safeJSONParse(sessionStorage.getItem("expirationDate"), "");
    const stopLo = safeJSONParse(sessionStorage.getItem("stopLoss"), "");
    const takeProf = safeJSONParse(sessionStorage.getItem("takeProfit"), [
      { id: 1, price: "" },
    ]);

    if (img) setPreviewUrl(img);
    if (trSymbol) setSelectedSymbol(trSymbol);
    if (signalAct) setSignalActionStatus(signalAct);
    if (accountStatus !== null) setAccountStatus(accountStatus);
    if (optionNote) setOptionalNote(optionNote);
    if (expire) setExpirationDate(expire);
    if (stopLo) setStopLoss(stopLo);
    if (takeProf) setTakeProfit(takeProf);

    const tf = safeJSONParse(sessionStorage.getItem("selectedTimeFrame"), "");

    const risk = safeJSONParse(sessionStorage.getItem("riskLevel"), 0);

    const conf = safeJSONParse(sessionStorage.getItem("confidence"), 0);

    if (tf) setSelectedTimeFrame(tf);
    setRiskLevel(risk);
    setConfidence(conf);

    console.log("sessionStorage:", sessionStorage);
  }, []);

  useEffect(() => {
    sessionStorage.setItem("signalImage", previewUrl);
  }, [previewUrl]);

  useEffect(() => {
    sessionStorage.setItem("tradingSymbol", JSON.stringify(selectedSymbol));
  }, [selectedSymbol]);

  useEffect(() => {
    sessionStorage.setItem("signalAction", signalActionStatus);
  }, [signalActionStatus]);

  useEffect(() => {
    sessionStorage.setItem("accountType", JSON.stringify(accountStatus));
  }, [accountStatus]);

  useEffect(() => {
    sessionStorage.setItem("optionalNote", JSON.stringify(optionalNote));
  }, [optionalNote]);

  useEffect(() => {
    sessionStorage.setItem("expirationDate", JSON.stringify(expirationDate));
  }, [expirationDate]);

  useEffect(() => {
    sessionStorage.setItem("stopLoss", JSON.stringify(stopLoss));
  }, [stopLoss]);

  useEffect(() => {
    sessionStorage.setItem("takeProfit", JSON.stringify(takeProfit));
  }, [takeProfit]);

  useEffect(() => {
    sessionStorage.setItem("trigger", JSON.stringify(trigger));
  }, [trigger]);

  useEffect(() => {
    sessionStorage.setItem(
      "selectedTimeFrame",
      JSON.stringify(selectedTimeFrame),
    );
  }, [selectedTimeFrame]);

  useEffect(() => {
    sessionStorage.setItem("riskLevel", JSON.stringify(riskLevel));
  }, [riskLevel]);

  useEffect(() => {
    sessionStorage.setItem("confidence", JSON.stringify(confidence));
  }, [confidence]);

  return (
    <>
      <div className=" h-[100vh] overflow-y-scroll bg-light   w-full ">
        {/* header */}
        <div className="flex z-20 shadow-lg flex-row justify-between items-center h-[77px] w-full fixed top-0 bg-white p-4 border-b-1 border-[#E5E7EB]">
          <div className="items-center text-center flex flex-row gap-2  justify-center">
            <GoArrowLeft
              onClick={onBackBtnClick}
              className="text-black  size-6 stroke-[1]"
            ></GoArrowLeft>
            <p className="font-extrabold text-xl text-black">Create Signal</p>
          </div>
          <button
            onClick={handleSubmit}
            className="rounded-[8px] h-[40px] py-2 px-6 text-white bg-primary text-[16px] font-semibold"
          >
            Publish
          </button>
        </div>
        {/* header */}

        {/* body  */}
        <div className=" h-max  overflow-y-auto px-4 pt-[calc(77px+1rem)]  w-full ">
          <div className="flex flex-col gap-3 h-full p-2 w-full justify-start items-cente pb-[80px]">
            <PackageModal
              onSelected={handleSelectedPackge}
              setIsPremiumSignal={setIsPremiumSignal}
            ></PackageModal>

            {/* signal image */}
            <div className="bg-white rounded-2xl px-4 shadow-md">
              <div className="flex flex-row gap-2 items-center justify-start">
                <div className="text-[18px] font-bold py-4">Signal Image</div>
                {previewUrl && (
                  <div className="w-max flex  justify-center items-center text-[12px] text-red-600">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setPreviewUrl("");
                        if (fileInputRef.current)
                          fileInputRef.current.value = "";
                      }}
                      className="justify-center flex items-center transition-colors px-2 py-1 rounded hover:bg-red-50"
                    >
                      <FaTrash className="mr-2" />
                      <span className={"pt-1"}>Remove Image</span>
                    </button>
                  </div>
                )}
              </div>

              <button
                onClick={handleDivClick}
                className="w-full mb-4 h-[190px] border-dashed border-2 border-[#D1D5DB] bg-[#F9FAFB] rounded-[8px] flex flex-col justify-center gap-3 items-center relative"
              >
                {isUploading ? (
                  <div className="flex flex-col gap-3 rounded-[8px] items-center justify-center z-20">
                    <div className="w-10 h-10 border-4 border-gray-300 border-t-blue-500 rounded-full animate-spin" />
                    <p>Uploading...</p>
                  </div>
                ) : previewUrl ? (
                  <>
                    <img
                      src={previewUrl}
                      className="w-full h-full rounded-[8px] object-contain pb-3 mt-3"
                      alt={""}
                    />
                    {/* Remove Button */}
                    {/*<button*/}
                    {/*    onClick={(e) => {*/}
                    {/*        e.stopPropagation(); // جلوگیری از باز شدن input*/}
                    {/*        setPreviewUrl("");*/}
                    {/*        if (fileInputRef.current)*/}
                    {/*            fileInputRef.current.value = "";*/}
                    {/*    }}*/}
                    {/*    className="absolute bottom-2 justify-center flex items-center text-[16px] text-gray-400 hover:text-red-600 transition-colors  px-2 py-1 rounded "*/}
                    {/*>*/}
                    {/*    <div className=" flex items-center justify-center pt-0">*/}
                    {/*        <FaTrash className="mr-2"/>*/}
                    {/*        <span className={"pt-1"}>Remove Image</span>*/}
                    {/*    </div>*/}
                    {/*</button>*/}
                  </>
                ) : (
                  <>
                    <FaCloudUploadAlt className="w-[45px] h-[36px] text-[#808080]" />
                    <div className="w-full h-max flex justify-center items-center flex-col">
                      <p className="text-[#808080] block text-[16px] leading-[24px]">
                        Tap to upload signal image
                      </p>
                      <p className="text-[#808080] block text-[12px] leading-[16px]">
                        PNG, JPG up to 5MB
                      </p>
                    </div>
                  </>
                )}

                <input
                  type="file"
                  ref={fileInputRef}
                  onChange={(e) => handleFileChange(e.target.files)}
                  className="hidden w-full h-full"
                />
              </button>
            </div>

            <TradeSymbol
              selectedItem={selectedSymbol}
              setOpenModal={setOpenModal}
            ></TradeSymbol>
            {/* trading symbol */}

            {/* Signal Action */}
            <div className="w-full h-[146px] bg-white shadow-lg rounded-[12px] p-6 flex flex-col justify-start items-start gap-2">
              <p className="text-[18px] leading-3 font-bold text-center h-[28px]">
                Signal Action
              </p>
              <div className="flex flex-row gap-4 justify-center items-center w-full">
                <button
                  onClick={() => setSignalActionStatus("buy")}
                  className={`basis-1/2 border-[2px] flex flex-row justify-center gap-1  rounded-[8px] h-[60px] items-center text-center border-[#D1D5DB]  text-[16px] hover:bg-green-100 font-semibold ${
                    signalActionStatus === "buy"
                      ? "bg-[#c7f6d8] text-[#15803D] border-[#15803D]"
                      : "border-[#D1D5DB] text-[#808080]"
                  }`}
                >
                  <GoArrowUp className=" font-bold  size-[14px] stroke-[2] text-center "></GoArrowUp>
                  <p className="pt-1">BUY</p>
                </button>
                <button
                  onClick={() => setSignalActionStatus("sell")}
                  className={`basis-1/2 border-[2px] flex flex-row justify-center gap-1 border-[#D1D5DB] rounded-[8px] hover:bg-gray-100 h-[60px] items-center text-center text-[16px] font-semibold ${
                    signalActionStatus === "sell"
                      ? "bg-[#fed1d1] text-[#DC2626] border-[#DC2626]"
                      : "border-[#D1D5DB] text-[#808080] "
                  }`}
                >
                  <GoArrowDown className=" font-bold  size-[14px] stroke-[2] text-center "></GoArrowDown>
                  <p className="pt-1">SELL</p>
                </button>
              </div>
            </div>
            {/* Signal Action */}

            {/* Account Type */}
            <div className="w-full min-h-[146px] bg-white shadow-lg rounded-[12px] p-6 flex flex-col justify-start items-start gap-2">
              <p className="text-[18px] leading-3 font-bold text-center h-[28px]">
                Price Type
              </p>
              <div className="flex flex-row gap-4 justify-center items-center w-full">
                <button
                  onClick={() => setAccountStatus(false)}
                  className={`basis-1/2 border-[2px]   rounded-[8px] h-[60px] items-center text-center    text-[16px] font-semibold ${
                    accountStatus === false
                      ? "border-primary-light bg-blue-50 text-[#2563EB]"
                      : "border-[#D1D5DB] text-[#808080]"
                  }`}
                >
                  <p>Current Price</p>
                </button>
                <button
                  onClick={() => setAccountStatus(true)}
                  className={`basis-1/2 border-[2px]  border-[#D1D5DB] rounded-[8px] h-[60px] items-center text-center hover:bg-gray-100 text-[16px] font-semibold ${
                    accountStatus === true
                      ? "border-[#9333EA] bg-[#F3E8FF] text-[#9333EA]"
                      : "border-[#D1D5DB] text-[#808080] "
                  }`}
                >
                  <p>Limit Order</p>
                </button>
              </div>
              {accountStatus && (
                <div className="flex-1 relative w-full">
                  <input
                    type="number"
                    step="0.00001"
                    placeholder={`Enter limit Price`}
                    value={priceTypeStatus}
                    onChange={(e) => setPriceTypeStatus(e.target.value)}
                    className="w-full p-3 pr-24 border border-gray-300 rounded-lg focus:border-primary focus:outline-none"
                  />
                  <button
                    type="button"
                    onClick={() => setPriceTypeStatus(8.2365)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-primary bg-light px-2 py-1 rounded"
                  >
                    Current: <span>{8.2365 || "--"}</span>
                  </button>
                </div>
              )}
            </div>
            {/* Account Type */}

            {/* Take Profit Targets */}
            <TakeProfitSection tps={takeProfit} setTps={setTakeProfit} />
            {/* Take Profit Targets */}

            {/* Stop Loss */}
            <div className="w-full h-[146px] bg-white shadow-lg rounded-[12px] p-6 flex flex-col justify-start items-start gap-4">
              <p className="text-[18px] leading-3 font-bold text-center">
                Stop Loss
              </p>

              <div className="relative w-full">
                <input
                  value={stopLoss}
                  type="number"
                  inputMode="numeric"
                  onChange={(e) => setStopLoss(e.target.value)}
                  placeholder="Enter stop loss price"
                  className="w-full h-[50px] border-[1px] border-[#D1D5DB] rounded-[8px] p-2 outline-none pr-24"
                  maxLength={20}
                />

                <button
                  onClick={() => setStopLoss(8.2365)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-primary bg-light px-2 py-1 rounded"
                >
                  Current: <span>{8.2365 || "--"}</span>
                </button>
              </div>
            </div>
            {/* Stop Loss  */}

            {/*Trigger*/}
            <div className="w-full h-[146px] bg-white shadow-lg rounded-[12px] p-6 flex flex-col justify-start items-start gap-4">
              <p className="text-[18px] leading-3 font-bold text-center">
                Trigger
              </p>

              <div className="relative w-full">
                <input
                  value={trigger}
                  type="number"
                  inputMode="numeric"
                  onChange={(e) => setTrigger(e.target.value)}
                  placeholder="Enter trigger"
                  className="w-full h-[50px] border-[1px] border-[#D1D5DB] rounded-[8px] p-2 outline-none pr-24"
                  maxLength={20}
                />
              </div>
            </div>

            {/* Time Frame */}
            <div className="w-full bg-white rounded-2xl shadow-lg p-6">
              <p className="text-[18px] leading-3 font-bold h-[34px]">
                Time Frame
              </p>

              <div className="grid grid-cols-3 gap-5">
                {timeFrames.map((item) => (
                  <button
                    key={item.value}
                    onClick={() => setSelectedTimeFrame(item.value)}
                    className={`h-[60px] rounded-2xl border-2 transition-all duration-200 flex items-center justify-center text-center whitespace-pre-line font-semibold text-[18px]
        ${
          selectedTimeFrame === item.value
            ? "bg-[#7A86F4] border-[#6A75E8] text-white shadow-md"
            : "bg-[#EEF1F6] border-[#C9CDD6] text-[#8B909B] hover:bg-[#E6EAF2]"
        }`}
                  >
                    {item.label}
                  </button>
                ))}
              </div>
            </div>

            {/*Risk Level & Confidence Percentage Selector*/}
            <PercentageModal
              title="Risk Level"
              description="Choose the risk percentage"
              value={riskLevel}
              onChange={setRiskLevel}
            />

            <PercentageModal
              title="Confidence"
              description="Choose the confidence percentage"
              value={confidence}
              onChange={setConfidence}
            />

            {/* expiration date */}
            <div className="w-full h-[200px] bg-white shadow-lg rounded-[12px] p-6 flex flex-col justify-start items-start gap-2">
              <p className="text-[18px] leading-3 font-bold text-center h-[28px]">
                Expiration Time
              </p>

              <div className="flex flex-col items-center justify-start w-full p-2 max-h-[110px] min-h-max gap-3">
                <input
                  type="datetime-local"
                  value={expirationDate}
                  onChange={(e) => setExpirationDate(e.target.value)}
                  className="w-full h-[50px] border border-gray-300 rounded-lg p-3 outline-none focus:border-primary"
                />

                <div className="flex gap-2 w-full justify-start h-[30px]">
                  {expirationOptions.map((option, index) => (
                    <button
                      key={index}
                      onClick={() => {
                        setExpirationDate(option.date);
                        setSelectedExpirationDate(option.label);
                      }}
                      className={`flex-1 bg-gray-100 text-secondary px-1 py-1 rounded-lg text-sm transition ${selectedExpirationDate === option.label && "bg-accent text-white"}`}
                    >
                      {option.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            {/* optionalNote */}
            <div className="w-full h-[240px] bg-white shadow-lg rounded-[12px] p-6 flex flex-col justify-start items-start gap-2">
              <p className="text-[18px] leading-3 font-bold text-center h-[28px]">
                Additional Notes (Optional)
              </p>
              <div className="w-full h-full  border-[1px] border-gray-200 bg-[#F9FAFB] rounded-xl flex flex-col justify-start gap-2 items-start text-start">
                <textarea
                  value={optionalNote}
                  placeholder="Add any additional information about this signal.."
                  className="w-full h-full p-3 text-start outline-none resize-none border-none rounded-xl bg-transparent"
                  onChange={(e) => setOptionalNote(e.target.value)}
                />
              </div>
            </div>
            {/* optionalNote */}
          </div>
        </div>

        <Symbols
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onSelect={(it) => {
            handleSelectItemsFromModal(it);
          }}
        />
        {/* body  */}
      </div>
    </>
  );
}
